exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popsale-ad {\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.ad-card {\n  position: relative;\n  overflow: hidden;\n  margin: 5px;\n}\n@media screen and (min-width: 840px) {\n.ad-card {\n    width: calc(100% - 10px);\n}\n}\n@media (max-width: 839px) and (min-width: 480px) {\n.ad-card {\n    width: calc(25% - 10px);\n    height: 276px;\n}\n}\n@media (max-width: 479px) {\n.ad-card {\n    width: calc(50% - 10px);\n    height: 276px;\n}\n}\n.primary-theme {\n  background: var(--mdc-theme-primary);\n}", ""]);

// exports
